import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

const Imprint = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="pt-20 bg-white">
      {/* Hero Section */}
      <section className="py-20 px-6 lg:px-12 bg-[#ff5200] text-white">
        <div className="max-w-5xl mx-auto text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-7xl font-bold"
          >
            {t.footer.imprint}
          </motion.h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto prose prose-lg">
          {language === 'de' ? (
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold mb-4">Impressum</h2>
                <h3 className="text-2xl font-bold mt-6 mb-3">Angaben gemäß § 5 TMG</h3>
                <p>
                  Lussho GmbH<br />
                  Sachsenhäuser Landwehrweg 159A<br />
                  60599 Frankfurt am Main<br />
                  Deutschland
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Vertreten durch</h3>
                <p>Esma Kaya Gürsoy & Yagmur Yüksel</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Kontakt</h3>
                <p>
                  Telefon: +49 172 306 8227<br />
                  E-Mail: hello@pikagency.de<br />
                  Website: www.pikagency.de
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Registereintrag</h3>
                <p>
                  Eingetragen im Handelsregister.<br />
                  Registergericht: Amtsgericht Frankfurt am Main<br />
                  Registernummer: HRB 136122
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Umsatzsteuer-ID</h3>
                <p>USt-IdNr. gemäß § 27 a Umsatzsteuergesetz: DE 450402974</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
                <p>
                  Esma Kaya Gürsoy & Yagmur Yüksel<br />
                  Lussho GmbH<br />
                  Sachsenhäuser Landwehrweg 159A<br />
                  60599 Frankfurt am Main
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">Haftungsausschluss</h2>
                
                <h3 className="text-2xl font-bold mb-3">Haftung für Inhalte</h3>
                <p className="mb-4">
                  Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr.
                </p>
                <p className="mb-4">
                  Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                </p>
                <p>
                  Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden entsprechender Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Haftung für Links</h3>
                <p className="mb-4">
                  Unsere Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte keine Gewähr übernehmen.
                </p>
                <p className="mb-4">
                  Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zu diesem Zeitpunkt nicht erkennbar.
                </p>
                <p>
                  Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Urheberrecht</h3>
                <p className="mb-4">
                  Alle auf dieser Website veröffentlichten Inhalte (Texte, Grafiken, Fotos, Videos, Layouts und sonstige Werke) unterliegen dem deutschen Urheberrecht.
                </p>
                <p className="mb-4">
                  Vervielfältigung, Bearbeitung, Übersetzung, Speicherung, Verarbeitung oder Wiedergabe von Inhalten in Datenbanken oder anderen elektronischen Medien und Systemen ist ohne ausdrückliche schriftliche Zustimmung der Lussho GmbH unzulässig.
                </p>
                <p className="mb-4">
                  Inhalte und Beiträge Dritter sind als solche gekennzeichnet. Die unautorisierte Vervielfältigung oder Weitergabe einzelner Inhalte oder kompletter Seiten ist nicht gestattet und strafbar.
                </p>
                <p className="mb-4">
                  Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch erlaubt.
                </p>
                <p>
                  Alle Rechte vorbehalten. Ohne ausdrückliche schriftliche Genehmigung darf kein Teil dieser Website in irgendeiner Form reproduziert oder unter Verwendung elektronischer Systeme verarbeitet, vervielfältigt oder verbreitet werden.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Online-Streitbeilegung und Verbraucherschlichtung</h3>
                <p className="mb-4">
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS-Plattform) bereit: <a href="https://ec.europa.eu/consumers/odr" className="text-[#ff5200] hover:underline" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>
                </p>
                <p>
                  Wir sind weder verpflichtet noch bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Geltungsbereich</h3>
                <p className="mb-2">Dieses Impressum gilt auch für die folgenden Social-Media-Profile:</p>
                <ul className="list-disc list-inside space-y-1">
                  <li>Instagram: <a href="https://www.instagram.com/pikagency.de/" className="text-[#ff5200] hover:underline" target="_blank" rel="noopener noreferrer">@pikagency.de</a></li>
                  <li>LinkedIn: <a href="https://www.linkedin.com/company/pikagency" className="text-[#ff5200] hover:underline" target="_blank" rel="noopener noreferrer">pikagency</a></li>
                  <li>Facebook: <a href="https://www.facebook.com/pikagency.de" className="text-[#ff5200] hover:underline" target="_blank" rel="noopener noreferrer">pikagency.de</a></li>
                </ul>
              </div>
            </div>
          ) : (
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold mb-4">Imprint</h2>
                <h3 className="text-2xl font-bold mt-6 mb-3">Information according to § 5 TMG</h3>
                <p>
                  Lussho GmbH<br />
                  Sachsenhäuser Landwehrweg 159A<br />
                  60599 Frankfurt am Main<br />
                  Germany
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Represented by</h3>
                <p>Esma Kaya Gürsoy & Yagmur Yüksel</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Contact</h3>
                <p>
                  Phone: +49 172 306 8227<br />
                  Email: hello@pikagency.de<br />
                  Website: www.pikagency.de
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Commercial Register</h3>
                <p>
                  Registered at the Local Court of Frankfurt am Main<br />
                  Registration Number: HRB 136122
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">VAT Identification Number</h3>
                <p>VAT ID according to § 27 a German VAT Act: DE 450402974</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Responsible for content under § 55 Abs. 2 RStV</h3>
                <p>
                  Esma Kaya Gürsoy & Yagmur Yüksel<br />
                  Lussho GmbH<br />
                  Sachsenhäuser Landwehrweg 159A<br />
                  60599 Frankfurt am Main
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">Disclaimer</h2>
                
                <h3 className="text-2xl font-bold mb-3">Liability for Content</h3>
                <p className="mb-4">
                  The contents of this website have been prepared with the utmost care. However, we cannot guarantee the accuracy, completeness, or timeliness of the information provided.
                </p>
                <p className="mb-4">
                  As a service provider, we are responsible for our own content on these pages under the general laws (§ 7 Abs. 1 TMG). According to §§ 8 to 10 TMG, we are not obliged to monitor transmitted or stored external information or to investigate circumstances that indicate illegal activity.
                </p>
                <p>
                  Obligations to remove or block the use of information under general law remain unaffected. Liability in this respect is only possible from the moment we become aware of a specific violation of law. Upon notification of such violations, we will remove the content immediately.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Liability for Links</h3>
                <p className="mb-4">
                  Our website contains links to external websites of third parties over whose content we have no control. Therefore, we cannot accept any liability for this external content.
                </p>
                <p className="mb-4">
                  The respective provider or operator of the linked pages is always responsible for their content. The linked pages were checked for possible legal violations at the time the links were created. Illegal content was not recognizable at that time.
                </p>
                <p>
                  Permanent monitoring of the linked pages is unreasonable without concrete evidence of a violation. If we become aware of any violations of law, we will remove such links immediately.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Copyright</h3>
                <p className="mb-4">
                  All contents published on this website (texts, graphics, photos, videos, layouts, and other works) are subject to German copyright law.
                </p>
                <p className="mb-4">
                  Reproduction, editing, translation, storage, processing, or reproduction of content in databases or other electronic systems is not permitted without the explicit written consent of Lussho GmbH.
                </p>
                <p className="mb-4">
                  Third-party content is marked as such. Unauthorized reproduction or distribution of individual content or complete pages is not permitted and may result in legal action.
                </p>
                <p className="mb-4">
                  Downloads and copies of this website are permitted only for private, non-commercial use.
                </p>
                <p>
                  All rights reserved. No part of this website may be reproduced or processed, duplicated, or distributed in any form using electronic systems without explicit written permission.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Online Dispute Resolution and Consumer Arbitration</h3>
                <p className="mb-4">
                  The European Commission provides a platform for online dispute resolution (OS platform): <a href="https://ec.europa.eu/consumers/odr" className="text-[#ff5200] hover:underline" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>
                </p>
                <p>
                  We are neither obliged nor willing to participate in a dispute resolution procedure before a consumer arbitration board.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">Scope</h3>
                <p className="mb-2">This imprint also applies to the following social media profiles:</p>
                <ul className="list-disc list-inside space-y-1">
                  <li>Instagram: <a href="https://www.instagram.com/pikagency.de/" className="text-[#ff5200] hover:underline" target="_blank" rel="noopener noreferrer">@pikagency.de</a></li>
                  <li>LinkedIn: <a href="https://www.linkedin.com/company/pikagency" className="text-[#ff5200] hover:underline" target="_blank" rel="noopener noreferrer">pikagency</a></li>
                  <li>Facebook: <a href="https://www.facebook.com/pikagency.de" className="text-[#ff5200] hover:underline" target="_blank" rel="noopener noreferrer">pikagency.de</a></li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Imprint;
